/**
 * The Firebase web app behind "Continue with Google" (2026-09-25).
 *
 * This is Firebase's PUBLIC web config: the browser SDK has to ship it, and
 * the API key only identifies the project (what it may do is set by the
 * console's providers, authorized domains and key restrictions), so it is
 * committed here. The Docker build passes no VITE_* values to this stage, so
 * the committed defaults are what production runs; VITE_FIREBASE_* overrides
 * exist for a local build pointed at another project. The server has the same
 * defaults (services/firebase-auth.js FIREBASE_WEB_DEFAULTS) and checks every
 * ID token against the same projectId.
 */
export const FIREBASE_WEB_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyCJzFlb-4KpSIChmBka2J5ULcHVpEH2QRE',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'faceshot-chopshop.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'faceshot-chopshop',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:242356426747:web:69495323cf3fdc75d71d5e',
};
